import React from "react";
import { Formik } from "formik";
import { TextField, withStyles, Button, Typography } from "@material-ui/core";
import * as Yup from "yup";

const styles = theme => ({
    root: {
        flexGrow: 1,
        paddingTop: theme.spacing(2)
    },

    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    cancel: {
        width: "120px",
        marginTop: "10px",
        marginRight: "10px",
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.buttonText.default
        }
    }
});

const MemoryForm = props => {
    const { classes, formSettings, initialValues, loading, handleSubmit, translations } = props;
    return (
        <div className={classes.root}>
            <Formik
                initialValues={initialValues}
                onSubmit={(values, { setSubmitting }) => {
                    setSubmitting(true);
                    handleSubmit(values);
                    setSubmitting(false);

                }}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="ComponentType"
                                value={values.ComponentType}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ComponentType && touched.ComponentType)}
                                placeholder={translations['component_type'] || 'Component type'}
                                label={translations['component_type'] || 'Component type'}
                                margin={"dense"}
                                fullWidth={true}
                                disabled={true}
                            />
                            <TextField
                                name="Vendor"
                                value={values.Vendor}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Vendor && touched.Vendor)}
                                placeholder={translations['vendor'] || 'Vendor'}
                                label={translations['vendor'] || 'Vendor'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="ComponentModel"
                                value={values.ComponentModel}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.ComponentModel && touched.ComponentModel)}
                                placeholder={translations['model'] || 'Model'}
                                label={translations['model'] || 'Model'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="SerialNumber"
                                value={values.SerialNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.SerialNumber && touched.SerialNumber)}
                                placeholder={translations['serial_number'] || 'Serial number'}
                                label={translations['serial_number'] || 'Serial number'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Width"
                                value={values.Width}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Width && touched.Width)}
                                placeholder={translations['width'] || 'Width'}
                                label={translations['width'] || 'Width'}
                                margin={"dense"}
                                fullWidth={true}
                                type={'number'}
                            />
                            <TextField
                                name="Size"
                                value={values.Size}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Size && touched.Size)}
                                placeholder={translations['size'] || 'Size'}
                                label={translations['size'] || 'Size'}
                                margin={"dense"}
                                fullWidth={true}
                                type={'number'}
                            />
                            <TextField
                                name="Slot"
                                value={values.Slot}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Slot && touched.Slot)}
                                placeholder={translations['slot'] || 'Slot'}
                                label={translations['slot'] || 'Slot'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="RAMType"
                                value={values.RAMType}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.RAMType && touched.RAMType)}
                                placeholder={translations['ram_type'] || 'RAMType'}
                                label={translations['ram_type'] || 'RAMType'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Description"
                                value={values.Description}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.Description && touched.Description)}
                                placeholder={translations['description'] || 'Description'}
                                label={translations['description'] || 'Description'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div style={{ textAlign: "right" }}>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        className={classes.submit}
                                        variant="contained"
                                        type="submit"
                                        disabled={isSubmitting || loading || !(isValid && dirty)}
                                    >
                                        {formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </div>
    );
};

export default withStyles(styles, { withTheme: true })(MemoryForm);
